import React, { useRef, useState, useEffect } from 'react';
import Text from './Text';

const BackGroundVideo = ({
  videoSrc,
  onEnded,
  onClick,
  nextVideoRef,
  showText,
  setShowText,
}) => {
  const videoRef = useRef(null);
  const [currentTextIndex, setCurrentTextIndex] = useState(0);

  const texts = [
    { title: 'Dobrodošli', subtitle: 'u našu agenciju za nekretnine' },
    { title: 'Pronađite dom', subtitle: 'uz našu pomoć' },
    { title: 'Kontaktirajte nas', subtitle: 'za najbolje ponude nekretnina' },
    { title: 'Ulaganje u nekretnine', subtitle: 'je ulaganje u budućnost' },
    { title: 'Personalizovana usluga', subtitle: 'za svaki korak kupovine' },
    { title: 'Prodajte brzo', subtitle: 'i po najboljoj ceni' },
  ];

  // Menjamo tekst na svakih 3 sekunde
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [texts.length]);

  // Event listener za kraj videa
  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return; // Dodali smo provjeru ovdje

    const handleVideoEnd = () => {
      if (nextVideoRef && nextVideoRef.current) {
        nextVideoRef.current.scrollIntoView({ behavior: 'smooth' });
        setShowText(false); // Sakrij tekst kada se skroluje na sledeći video
      }
    };

    videoElement.addEventListener('ended', handleVideoEnd);

    return () => {
      videoElement.removeEventListener('ended', handleVideoEnd);
    };
  }, [nextVideoRef, setShowText]);

  return (
    <div className="relative w-full h-screen overflow-hidden" onClick={onClick}>
      <video
        ref={videoRef}
        className="absolute top-0 left-0 w-full h-full object-cover"
        src={videoSrc}
        autoPlay
        muted
        playsInline
        onEnded={onEnded} // Poziva onEnded kada video završi
        style={{ zIndex: 20 }}
      />

      {showText && (
        <div className="absolute inset-0 flex flex-col justify-center items-center text-center text-white z-30">
          {/* Prikaz teksta sa animacijom */}
          <Text
            key={currentTextIndex}
            title={texts[currentTextIndex].title}
            subtitle={texts[currentTextIndex].subtitle}
          />
        </div>
      )}
    </div>
  );
};

export default BackGroundVideo;
